import { set_dto_MobileAppCategory } from "../../../../classes/dto-setters/dto-setter";
import { PT_CATEGORYWISE_MERCHANT } from "../../../../routes/stack/paths/pt-home";
import { ENCRYPT_STORAGE_SESSION } from "../../../../config/config";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { KEY_GENERATOR } from "../../../../functions/funtion";
import { dto_common } from "../../../../classes/dto-common";
import { Container } from "react-bootstrap";
import { Colors } from "../../../../util/colors";
import HorizontalCategory from "./horizontol-category";
import React from "react";

export default class ViewCategory extends React.PureComponent {
  render() {
    return (
      <>
        <Container
          style={{ overflowY: "hidden" }}
          className="fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 5,
              marginBottom: 0,
              padding: "0px 10px",
            }}
          >
            <div
              style={{
                fontSize: Font.MainHeading,
                color: Colors.ThemeBGcolor,
                fontFamily: F_Fammily.Medium,
              }}
            >
              CATEGORY
            </div>

            <div style={{ fontSize: 13, fontWeight: "bold", display: "none" }}>
              More
              <i className="bi bi-chevron-right" style={{ marginLeft: 10 }} />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              overflowY: "auto",
            }}
          >
            {this.props.data.map((rs) => {
              if (rs.MACImageUrl === "" && rs.MACImageUrl === "N/A") {
                rs.MACImageUrl = dto_common.DefaultImageUrl;
              }
              return (
                <HorizontalCategory
                  description={rs.MobileAppCategory}
                  url={rs.MACImageUrl}
                  key={KEY_GENERATOR()}
                  callBack={async () => {
                    ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                    await Api_DrawAnalyticalPath(45, rs.MACID);
                    set_dto_MobileAppCategory(rs);
                    this.props.navigate(PT_CATEGORYWISE_MERCHANT);
                  }}
                />
              );
            })}
          </div>
        </Container>
      </>
    );
  }
}
